import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';

@NgModule({
  exports: [
    LoaderComponent
  ],
  imports: [
    CommonModule,
  ],
  declarations: [
    LoaderComponent
  ]
})
export class LoaderModule { }
